<ng-template [ngIf]="ripartizioneForm">
    <div class="col-sm-12 coldx">
        <h4 *ngIf="title">{{title}}</h4>
        <form [formGroup]="ripartizioneForm" (ngSubmit)="update();">
            <div class="row">
                <div comboModInput [control]="ripartizioneForm.controls['soggetto']" class="col-sm-4"
                    [labelInput]="'Societ&agrave;'" [mandatory]="true" formControlName="soggetto"
                    [labelOption]="'nome'" [optionsCombo]="soggettoOptions" [labelNoSelection]="'Scegli Societ&agrave;'"
                    [objectReference]="request.soggetto" (onReturn)="request.soggetto = $event"
                    [ngModel]="request.soggetto"></div>

                <div textInputCurrency class="col-sm-4" [labelInput]="'Percentuale (%)'" [mandatory]="true" formControlName="percentualeParcella" (onReturn)="onChangePercentuale($event);"
                    [isNaturalNumber]="true" [location]="'SezioneEconomica'" [maxValue]="100" [(ngModel)]="request.percentualeParcella"></div>

                <div textInputCurrency class="col-sm-4" [labelInput]="'Importo'" formControlName="importoParcella" [submitPending]="true"
                    [location]="'SezioneEconomica'" [ngModel]="request.parcella?.importoParcella"></div>
            </div>

            <div class="row">
                <p class="mandatory col-sm-12">
                    <em>* Campi obbligatori</em>
                </p>
            </div>
            <div class="row">
                <p class="col-sm-3 col-xs-6">
                    <button type="button" class="btn btn-outline-secondary btn-block"
                        (click)="createForm();">Reset</button>
                </p>
                <p submitButton [disabled]="!ripartizioneForm.valid || request.percentualeParcella>100"
                    class="col-sm-3 col-xs-6 col-sm-offset-6" [labelButton]="'Salva'"></p>
            </div>
        </form>
    </div>
</ng-template>